import { jsx } from '@emotion/react';
import { IconSVGProps } from './IconSVG.interface';
import * as icons from './index';

type IconOptions = {
  title?: string;
  css?: any;
  className?: string;
};

const IconSVG: React.FC<IconSVGProps> = ({
  iconName,
  iconSize = 24,
  css,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  before,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  iconOnly,
  ...rest
}) => {
  const iconOptions: IconOptions = { ...rest };

  if (typeof css !== 'undefined') {
    iconOptions.css = css;
  }

  if (typeof iconSize !== 'undefined') {
    iconOptions.css = {
      width: `${iconSize}px`,
      height: `${iconSize}px`,
      ...iconOptions.css,
    };
  }

  return jsx(icons[iconName], iconOptions);
};

export default IconSVG;
